<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.texts.dashboard.alerts.title') }}
    </h1>
    <p>{{ $t('documentation.texts.dashboard.alerts.paragraph1') }}</p>
    <h2 class="primary--text">
      {{ $t('documentation.texts.dashboard.alerts.title1') }}
    </h2>
    <v-img
      style="
        width: 100%;
        max-width: 600px;
        margin-top: 10px;
        margin-bottom: 20px;
      "
      contain
      :src="pic1Name"
    />
    <p>{{ $t('documentation.texts.dashboard.alerts.paragraph2') }}</p>
    <ul>
      <li>
        <b>
          {{ $t('documentation.texts.dashboard.alerts.li1Title') }}
        </b>
        {{ $t('documentation.texts.dashboard.alerts.li1') }}
      </li>
      <li>
        <b>
          {{ $t('documentation.texts.dashboard.alerts.li2Title') }}
        </b>
        {{ $t('documentation.texts.dashboard.alerts.li2') }}
      </li>
      <li>
        <b>
          {{ $t('documentation.texts.dashboard.alerts.li3Title') }}
        </b>
        {{ $t('documentation.texts.dashboard.alerts.li3') }}
      </li>
    </ul>
    <br />
    <h2 class="primary--text">
      {{ $t('documentation.texts.dashboard.alerts.title2') }}
    </h2>
    <v-img
      style="
        width: 100%;
        max-width: 400px;
        margin-top: 10px;
        margin-bottom: 20px;
      "
      contain
      :src="pic2Name"
    />
    <p>{{ $t('documentation.texts.dashboard.alerts.paragraph3') }}</p>
    <h2 class="primary--text">
      {{ $t('documentation.texts.dashboard.alerts.title3') }}
    </h2>
    <v-img
      style="
        width: 100%;
        max-width: 400px;
        margin-top: 10px;
        margin-bottom: 20px;
      "
      contain
      :src="pic3Name"
    />
    <p>{{ $t('documentation.texts.dashboard.alerts.paragraph4') }}</p>
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/dashboard/' +
        this.$t('documentation.texts.dashboard.alerts.pic1') +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/dashboard/' +
        this.$t('documentation.texts.dashboard.alerts.pic2') +
        '.png')
    },
    pic3Name() {
      return require('@/assets/documentation/dashboard/' +
        this.$t('documentation.texts.dashboard.alerts.pic3') +
        '.png')
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
